const ReportDescription = {
  method_simple: 'All Rows',
  method_grouped: 'Group rows',
  block_conditions: 'You can use conditions to refine reports to show only results that meet specific criteria.',
  block_columns_simple: 'Please add one or more report columns.',
  block_columns_grouped: 'Please add one or more report columns and their function.',
  block_sort: 'You can set sort fields to control the order in which data appears in a report.',
  block_formatter: 'You can set column format to change default style of report value.',
  block_preview: 'Click on preview to generate the report.',
  add_sort_disabled_no_fields: 'To add sort first select report columns',
  add_formatter_disabled_no_fields: 'To add column format first select report columns',
  add_conditions_disabled_no_entity: 'To add conditions first select report entity',
  add_columns_disabled_no_entity: 'To add columns first select report entity',
};

export default ReportDescription;
